import React from "react";
import styled from "styled-components";
import {MenuItemStyleProps} from "components/DateRangeDropdown/types";
import {getPresetsByCategory} from "components/DateRangeDropdown/utils/datePresets";

interface PresetMenuItemProps {
    category: 'Weeks' | 'Months' | 'Years';
    selectedData: string;
    setSelectedData: (label: string) => void;
    menuItemStyle?: MenuItemStyleProps;
}

const PresetMenuItem: React.FC<PresetMenuItemProps> = ({
                                                           category,
                                                           selectedData,
                                                           setSelectedData,
                                                           menuItemStyle = {}
                                                       }) => {
    const presets = getPresetsByCategory(category);

    return (
        <>
            {presets.map((label: string) => (
                <MenuItem
                    key={label}
                    onClick={() => setSelectedData(label)}
                    $width={menuItemStyle.width}
                    $height={menuItemStyle.height}
                    $fontSize={menuItemStyle.fontSize}
                    $padding={menuItemStyle.padding}
                    style={{
                        color: selectedData === label ? "rgba(0,0,0,1)" : "rgba(0,0,0,0.5)",
                        background: selectedData === label ? "rgba(226,229,255,1)" : "",
                    }}
                >
                    {label}
                </MenuItem>
            ))}
        </>
    );
};

export default PresetMenuItem;

const MenuItem = styled.div<{
    $width?: string;
    $height?: string;
    $fontSize?: string;
    $padding?: string;
}>`
    width: ${(props) => props.$width || "172px"};
    height: ${(props) => props.$height || "39px"};
    font-size: ${(props) => props.$fontSize || "14px"};
    padding: ${(props) => props.$padding || "10px"};
    border-radius: 10px;
    color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
        background: rgba(226, 229, 255, 1);
        color: rgba(0, 0, 0, 1);
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`;
